import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { CloseButton, IconButton, Row, SegmentControl, Typography } from 'seagull';
import { Brush, Desktop, Mobile } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { Intent } from '~/infra/access-control';
import { PreviewState } from '../ClientOnboarding.utils';
import styles from './PreviewBanner.module.scss';
export const GetPreviewBannerTID = (parentTestId)=>getTestIds({
        parentTestId
    });
export const PreviewBanner = (param)=>{
    let { testId = 'cob-preview-banner-new', previewState, localPreviewState, onToggleBrandSetup, onDismiss, showBrandSetupButton = false, deviceView = 'desktop', onDeviceViewChange } = param;
    const { t: texts } = useLocaleKeys('clientFlow.previewBanner');
    const hasButtons = onDismiss || showBrandSetupButton && onToggleBrandSetup || onDeviceViewChange && deviceView !== undefined;
    const { PreviewBannerTestIds } = useMemo(()=>GetPreviewBannerTID(testId), [
        testId
    ]);
    if (hasButtons) {
        return /*#__PURE__*/ _jsxs(Row, {
            className: styles.headerContainer,
            testId: PreviewBannerTestIds.Root(),
            alignItems: "center",
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    className: styles.message,
                    testId: PreviewBannerTestIds.Message(),
                    children: texts.previewModeMessage()
                }),
                /*#__PURE__*/ _jsxs(Row, {
                    gap: 16,
                    alignItems: "center",
                    children: [
                        onDeviceViewChange && /*#__PURE__*/ _jsx(SegmentControl, {
                            options: [
                                {
                                    value: 'desktop',
                                    icon: /*#__PURE__*/ _jsx(Desktop, {}),
                                    testId: 'device-desktop'
                                },
                                {
                                    value: 'mobile',
                                    icon: /*#__PURE__*/ _jsx(Mobile, {}),
                                    testId: 'device-mobile'
                                }
                            ],
                            value: deviceView,
                            onChange: onDeviceViewChange,
                            variant: "icon",
                            "aria-label": texts.viewMode(),
                            bi: {
                                name: 'device_preview'
                            },
                            testId: PreviewBannerTestIds.DeviceToggle()
                        }),
                        showBrandSetupButton && onToggleBrandSetup && previewState !== PreviewState.SetupBrand && /*#__PURE__*/ _jsx(IconButton, {
                            bi: {
                                name: 'toggle_brand_setup'
                            },
                            intent: Intent.BrandSetup,
                            preferIntentTooltip: true,
                            skin: "transparent",
                            className: "".concat(styles.brushBtn, " ").concat(localPreviewState === PreviewState.SetupBrand ? styles.brushBtnActive : ''),
                            testId: PreviewBannerTestIds.BrushButton(),
                            onClick: onToggleBrandSetup,
                            tooltip: {
                                title: 'Customize brand'
                            },
                            children: /*#__PURE__*/ _jsx(Brush, {})
                        }),
                        /*#__PURE__*/ _jsx(CloseButton, {
                            bi: {
                                name: 'close_client_preview'
                            },
                            testId: PreviewBannerTestIds.CloseButton(),
                            skin: "transparent",
                            className: styles.closeBtn,
                            onClick: onDismiss
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx(Typography, {
        weight: "normal",
        skin: "standard",
        className: styles.messageOnly,
        testId: PreviewBannerTestIds.Message(),
        children: texts.previewModeMessage()
    });
};
